/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingSummaryBase {
    getFixupPrototypeFunction() { return BillingSummaryBase.fixupPrototype; }

    static newInstance(model: Partial<BillingSummaryBase>): BillingSummaryBase {
        let obj = Object.assign(new BillingSummaryBase(), model);
        BillingSummaryBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingSummaryBase>): BillingSummaryBase {
        if (!model) return null;
        return BillingSummaryBase.newInstance(<BillingSummaryBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingSummaryBase) {
        if (!obj) return;

        models.BillingSummaryBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingSummaryBase): boolean {
        Object.setPrototypeOf(obj, BillingSummaryBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.descendant_service_account_query) {
            models.DescendantServiceAccountQuery.fixupPrototype(this.descendant_service_account_query);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * Descendant service account query filter
     */
    descendant_service_account_query: models.DescendantServiceAccountQuery;

    /**
     * If set, redirect the query to billing platform line items summary collection
     */
    for_platform: boolean;

    /**
     * Platform source to scope the results to. Implies for_platform. If not set, only Kubernetes rows are returned
     */
    platform: models.Platforms;

    /**
     * If set, do not group by service account
     */
    skip_service_account_grouping: boolean;

}
